<template>
  <el-card class="box-card d-flex flex-column align-items-center" shadow="never">
    <slot/>
  </el-card>
</template>

<script>
export default {
  name: 'ContentBodyCard',
  props: [],
  methods: {
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-card__body {
  width: 100%;
  max-width: $md;
}
</style>
